<template>
  <div class="col-12 col-sm-6 col-md-4 d-flex pb-1 pt-1 px-1 mt-n1" :class="containerDynamicClass">
    <article class="template-item" :class="itemDynamicClass" v-if="item">
      <div class="template-body" @click.stop="selectTemplate">
        <!-- Ribbon -->
        <div class="ribbon ribbon-primary" v-if="item && item.status == 'new' && !forDashboard">
          <span class="typo-paragraph12 typo-medium">{{ $t("generals.new") }}</span>
        </div>
        <div class="ribbon ribbon-warning" v-if="item && item.status == 'soon' && !forDashboard">
          <span class="typo-paragraph12 typo-medium">{{ $t("template.soon") }}</span>
        </div>
        <!-- Thumbnails -->
        <div class="thumbnail image-container" :class="thumbnailDynamicClass" v-if="isDisplayThumbnail">
          <!-- <img src="@/core/assets/recentPage.jpg" /> -->
          <img v-lazyload :src="tinyThumb" :data-src="thumbnail" />
        </div>
        <div class="thumbnail" v-else>
          <svg width="213" viewBox="0 0 213 231" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="213" height="72" rx="5" />
            <rect y="122" width="112" height="28" rx="5" />
            <path d="M0 169C0 166.239 2.23858 164 5 164H208C210.761 164 213 166.239 213 169V231H0V169Z" />
            <rect y="82" width="110" height="9" rx="4.5" />
            <rect y="101" width="73" height="9" rx="4.5" />
            <rect x="120" y="122" width="93" height="9" rx="4.5" />
            <rect x="120" y="141" width="71" height="9" rx="4.5" />
          </svg>
        </div>
        <div :class="{ 'bottom-17px': forDashboard }" class="d-flex justify-content-center align-items-center template-type" v-if="item.plan == 'professional'">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.32287 0.198189L6.81001 3.14447L9.67229 3.42803C9.86921 3.44439 10.0156 3.61729 9.99921 3.81421C9.99216 3.89912 9.95503 3.97873 9.89452 4.03871L7.53891 6.37342L8.41226 9.54592C8.46348 9.7388 8.34864 9.93668 8.15577 9.9879C8.07037 10.0106 7.97963 10.0012 7.9007 9.96148L4.99887 8.52457L2.10104 9.95971C1.92274 10.0494 1.70553 9.9775 1.61588 9.79921C1.57619 9.72027 1.56679 9.62954 1.58947 9.54414L2.46282 6.37164L0.10544 4.03693C-0.0349078 3.89783 -0.0359225 3.6713 0.103174 3.53095C0.163151 3.47043 0.242756 3.43331 0.327667 3.42625L3.18994 3.14269L4.67486 0.198189C4.76648 0.0192454 4.98582 -0.0515434 5.16476 0.0400779C5.23275 0.0748879 5.28806 0.130202 5.32287 0.198189Z" fill="#FFAA00" />
          </svg>
          <span>Pro</span>
        </div>
      </div>

      <div class="dashboard__template-overlay" v-if="forDashboard">
        <h5 class="body-14-medium text-light-high flex-v-center dashboard__template-overlay_item-name template-name">
          {{ item.name }}
        </h5>
        <p class="body-12-regular typo-regular dashboard__template-overlay_tag-name mt-half template-name">
          {{ tagsName }}
        </p>
        <div class="mt-2 d-flex justify-content-between">
          <button class="btn btn-default btn-light3 dashboard__template-btn d-flex justify-content-center align-items-center btn-preview mr-1" @click="onPreviewTemplate(item.id)" :disabled="isGemPagesV7 && !previewLinkV7" v-popover:tooltip.top="$t('generals.preview')">
            <i class="icon icon-preview"></i>
          </button>
          <button class="btn btn-default btn-primary dashboard__template-btn flex-grow-1" @click="showUpgradePopup" v-if="item.plan == 'professional' && !shopIsPro">
            <!-- Edit -->
            <span class="d-flex justify-content-center align-items-center body-14-medium">
              <span>{{ editBtnText }}</span>
              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-12px">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.22916 7.95832C1.94151 7.95832 1.70832 8.19151 1.70832 8.47916V15.7708C1.70832 16.0585 1.94151 16.2917 2.22916 16.2917H11.6042C11.8918 16.2917 12.125 16.0585 12.125 15.7708V8.47916C12.125 8.19151 11.8918 7.95832 11.6042 7.95832H2.22916ZM0.666656 8.47916C0.666656 7.61622 1.36622 6.91666 2.22916 6.91666H11.6042C12.4671 6.91666 13.1667 7.61622 13.1667 8.47916V15.7708C13.1667 16.6338 12.4671 17.3333 11.6042 17.3333H2.22916C1.36622 17.3333 0.666656 16.6338 0.666656 15.7708V8.47916Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.91666 1.70832C5.19076 1.70832 3.79166 3.10744 3.79166 4.83332V7.43749C3.79166 7.72514 3.55847 7.95832 3.27082 7.95832C2.98318 7.95832 2.74999 7.72514 2.74999 7.43749V4.83332C2.74999 2.53214 4.61547 0.666656 6.91666 0.666656C9.21784 0.666656 11.0833 2.53213 11.0833 4.83332V7.43749C11.0833 7.72514 10.8501 7.95832 10.5625 7.95832C10.2748 7.95832 10.0417 7.72514 10.0417 7.43749V4.83332C10.0417 3.10743 8.64254 1.70832 6.91666 1.70832Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.65323 11.3884C7.24644 10.9816 6.58689 10.9816 6.1801 11.3884C5.7733 11.7952 5.7733 12.4548 6.1801 12.8616C6.58689 13.2683 7.24644 13.2683 7.65323 12.8616C8.06003 12.4548 8.06003 11.7952 7.65323 11.3884ZM8.3898 10.6518C7.57621 9.83825 6.25712 9.83825 5.44353 10.6518C4.62993 11.4654 4.62993 12.7845 5.44353 13.5981C6.25712 14.4117 7.57621 14.4117 8.3898 13.5981C9.2034 12.7845 9.2034 11.4654 8.3898 10.6518Z" fill="white" />
              </svg>
            </span>
          </button>
          <button class="btn btn-default btn-primary dashboard__template-btn flex-grow-1" @click="onStartUsingTemplate(item)" v-else-if="isAvailable && !hidePrimary">
            <!-- Edit -->
            <span class="body-14-medium">
              {{ editBtnText }}
            </span>
          </button>
        </div>
      </div>

      <div class="overlay" v-else>
        <div class="actions btn-block">
          <button class="btn btn-block btn-default btn-light3" @click="onPreviewTemaplte(item.id)" :disabled="isGemPagesV7 && !previewLinkV7" v-if="isAvailable">
            {{ $t("generals.preview") }}
          </button>
          <button class="btn btn-block btn-default btn-primary mt-1" @click="showUpgradePopup" v-if="item.plan == 'professional' && !shopIsPro">
            {{ $t("generals.buttons.upgradeToEdit") }}
          </button>
          <button class="btn btn-block btn-default btn-primary mt-1" @click="onStartUsingTemplate(item)" v-else-if="isAvailable && !hidePrimary">
            {{ $t("generals.startEdit") }}
          </button>
        </div>
      </div>

      <div class="template-footer">
        <div class="row">
          <div class="col-8">
            <h5 class="typo-button14 typo-medium text-light-high flex-v-center template-name">
              {{ item.name }}
            </h5>
          </div>
          <div class="col-4 typo-paragraph10 typo-regular text-text-light-disabled additions">
            <div class="views-count">
              <span>{{ item.view || 0 }}</span>
              <i class="icon icon-view"></i>
            </div>
          </div>
        </div>
        <p class="typo-paragraph12 typo-regular text-light-low mt-half" :class="{ 'template-name': forDashboard }">
          {{ tagsName }}
        </p>
      </div>
    </article>
    <!-- Loading -->
    <article class="template-item" v-else>
      <div class="template-body">
        <div class="thumbnail image-container skeleton" :class="forDashboard ? 'skeleton-light-grey-200' : 'skeleton-light'"></div>
      </div>

      <div class="template-footer">
        <div class="row">
          <div class="col-8">
            <h5 class="typo-button14 typo-medium text-light-high flex-v-center template-name skeleton" :class="forDashboard ? 'skeleton-light-grey-200' : 'skeleton-light'"></h5>
          </div>
          <div class="col-4 typo-paragraph10 typo-regular text-text-light-disabled additions">
            <div class="views-count skeleton" :class="forDashboard ? 'skeleton-light-grey-200' : 'skeleton-light'"></div>
          </div>
        </div>
        <p class="typo-paragraph12 typo-regular text-light-low mt-half tags-name skeleton" :class="forDashboard ? 'skeleton-light-grey-200' : 'skeleton-light'"></p>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from "vuex";

import newObsLocalData from "@/utils/newObsLocalData.js";
import trackEvent, { TEMPLATE_INSERT_EVENT_ID } from "@/utils/tracker.js";

export default {
  name: "PageTemplateItem",
  components: {},
  props: {
    item: {
      type: Object
    },
    type: String,
    primaryAction: {
      type: Function,
      required: false,
      default: () => () => false
    },
    secondaryAction: {
      type: Function,
      required: false,
      default: () => () => false
    },
    hidePrimary: {
      type: Boolean,
      default: false
    },
    numberPerPage: {
      type: Number,
      default: 4
    },
    noMarginTop: {
      type: Boolean,
      default: false
    },
    forDashboard: {
      type: Boolean,
      default: false
    },
    shopIsPro: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editBtnText: "Edit",
      userIndustries: []
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesV7) || window.___gemShopInfo.shopType.isGemPagesV7 || false;
    },
    containerDynamicClass() {
      return {
        "col-lg-3 col-mlg-3 col-xl-3": this.numberPerPage == 4,
        "overflow-hidden": this.forDashboard
      };
    },
    itemDynamicClass() {
      const dynamicClass = {
        "mt-0": this.noMarginTop,
        unclickable: this.hidePrimary
      };
      dynamicClass[this.item.status] = !this.forDashboard;

      return dynamicClass;
    },
    thumbnailDynamicClass() {
      return {
        "no-hover": this.forDashboard
      };
    },
    isDisplayThumbnail() {
      return this.isGemPagesV7 ? this.thumbnailV7 !== '' : this.item.thumbnail_cloudinary;
    },
    previewLinkV7() {
      const previewUrl = this.item.themePageMetas.edges.find((x) => x.node.key === 'global_preview_url');
      return previewUrl?.node.value;
    },
    thumbnailV7() {
      const thumb = this.item.themePageMetas.edges.find((x) => x.node.key === 'global_thumbnail');
      return thumb?.node.value ?? '';
    },
    thumbnail() {
      if (this.isGemPagesV7) {
        return this.thumbnailV7;
      }
      if (this.item && this.item.thumbnail_cloudinary) return this.item.thumbnail_cloudinary.replace("http://", "https://");
      return "";
    },
    tinyThumb() {
      if (this.isGemPagesV7) {
        return this.thumbnailV7;
      }
      if (this.item && this.item.thumbnail_cloudinary_small) return this.item.thumbnail_cloudinary_small.replace("http://", "https://");
      return "";
    },
    // statusTrans() {
    //   let value = this.item.status;
    //   if (value === "published") {
    //     return this.$t("generals.free");
    //     // return "Free";
    //   }
    //   if (value === "soon") {
    //     return this.$t("generals.comingSoon");
    //     // return "Coming soon";
    //   }
    //   return "";
    // },
    tagsName() {
      if (!this.item) return "";
      if (!this.item.tags || !this.item.tags.length) return this.$t("generals.all");
      let tagsList = this.item.tags.split(",").map(x => x.trim());
      let output;

      for (let i = 0; i < tagsList.length; i++) {
        const tag = tagsList[i];
        if (this.userIndustries.includes(tag)) {
          let tagName = this.$t(`page.category.${tag}`);
          if (tagName && tagName.length) output = tagName;
        } else if (i == 0) {
          if (tag == "blog") {
            output = this.$t("page.blog");
          } else if (tag.endsWith("pages")) {
            let tagName = this.$tc(`page.${tag}`, 1);
            if (tagName && tagName.length) output = tagName;
          } else {
            let tagName = this.$t(`page.category.${tag}`);
            if (tagName && tagName.length) output = tagName;
          }
        }
      }

      // tagsList.forEach(tag => {
      // })

      return output;
      // .filter((value, index, self) => {
      //   return self.indexOf(value) === index;
      // })
      // .join(", ");
    },
    isAvailable() {
      return this.item.status !== "soon";
    }
  },
  created() {},
  mounted() {
    const shopifyDomain = this.shopInfo.shopifyDomain;
    if (newObsLocalData.check(shopifyDomain)) {
      const lastSurvey = newObsLocalData.get(shopifyDomain);
      if (lastSurvey && lastSurvey.store && lastSurvey.store.industries) {
        const userIndustries = lastSurvey.store.industries;
        userIndustries.reverse().forEach(item =>
          this.userIndustries.unshift(
            item
              .toLowerCase()
              .replace(" & ", "-")
              .replace(", ", "-")
              .replace(" ", "-")
          )
        );
      }
    } else {
      const surveys = this.shopInfo && this.shopInfo.surveys;
      if (!surveys) return;
      const newSurveyObs = surveys.filter(sv => sv.handle == "onboarding-v2") || [];
      if (newSurveyObs && newSurveyObs.length > 0) {
        newSurveyObs?.industries?.reverse().forEach(item =>
          this.userIndustries.unshift(
            item
              .toLowerCase()
              .replace(" & ", "-")
              .replace(", ", "-")
              .replace(" ", "-")
          )
        );
      }
    }
  },
  methods: {
    selectTemplate() {
      if (this.item.plan == "professional" && !this.shopIsPro) return;
      if (this.isAvailable && !this.hidePrimary) {
        this.primaryAction(this.item.id);
        trackEvent({
          eventId: TEMPLATE_INSERT_EVENT_ID,
          properties: {
            insert_template_id: this.item.id,
            insert_template_name: this.item.name
          }
        });
      }
    },
    showUpgradePopup() {
      this.$store.commit("account/SHOW_PLAN_MODAL");
    },
    onStartUsingTemplate(template) {
      this.primaryAction(template.id);
      trackEvent({
        eventId: TEMPLATE_INSERT_EVENT_ID,
        properties: {
          insert_template_id: template.id,
          insert_template_name: template.name
        }
      });
    },
    onPreviewTemplate(templateId) {
      this.secondaryAction(templateId);
    }
  }
};
</script>

<style lang="scss" scoped>
.template-item {
  @include trans-all;
  position: relative;
  background: $light1;
  padding: 0;
  margin-top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: $radius;
  border: solid 1px #D6D6D6;
  overflow: hidden;

  &:hover {
    border: 1px solid #5B5B5B;
  }

  &.unclickable {
    .template-body {
      cursor: default;
    }
  }

  .image-container {
    img {
      // transition: transform 2s linear;
      width: 100%;
      &:not(.v-lazy-loaded) {
        filter: blur(10px);
      }
    }

    // &:hover > img {
    //   /* margin-top: calc(-200% + 183px); */
    //   transform: translateY(calc(-100% + 200px));
    // }
  }

  .thumbnail {
    flex: 1;
    width: 100%;
    // min-height: 200px;
    // max-height: 118.421052632%;
    padding-top: 118.421052632%;
    overflow: hidden;
    border-radius: $radius $radius 0 0;
    position: relative;

    img,
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    &:hover {
      img {
        transform: translateY(calc(-100% + 300px));
      }
    }

    img {
      transition: transform 2s linear;
      width: 100%;
    }
    svg {
      width: 100%;
      path,
      rect {
        fill: $cTeal;
      }
    }
  }

  .btn-preview {
    width: 40px;
    height: 40px;
    font-size: 20px !important;
    .icon {
      font-size: 20px !important;
      margin: 0 !important;
      color: $textLightModeHigh !important;
    }
  }

  .ribbon {
    width: 50px;
    height: 50px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;

    span {
      position: absolute;
      display: block;
      width: 80px;
      padding: 4px 0;
      text-align: center;
      top: 9px;
      right: -51%;
      text-transform: uppercase;
      transform: rotate(45deg);
      // color: $textDarkModeHigh;
      color: $light1;
    }

    &-primary span {
      background-color: $mono3;
    }

    &-warning span {
      background-color: $accent-yellow;
    }
  }

  .actions {
    padding: 16px;
    background: transparent;
  }

  .template {
    &-body {
      position: relative;
      flex: 1;
      cursor: pointer;
    }

    &-footer {
      position: relative;
      background: $light1;
      border-radius: 0px 0px $radius $radius;
      padding: 10.5px 16px;
      margin-top: auto;

      .additions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .views-count {
        display: flex;
        align-items: center;
        i.icon {
          font-size: 12px;
          line-height: 12px;
          margin-left: 3px;
        }
      }

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: $light3;
      }
    }

    &-name {
      @include ellipsis;
    }
  }

  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    // height: 100%;
    // background: rgba($light1, 0.96);

    background: linear-gradient(180deg, rgba(242, 240, 240, 0.1) 0%, rgba(172, 170, 170, 0.3) 39.41%, #cfcfcf 100%);
    display: flex;
    align-items: flex-end;
    transition: all 0.3s ease-in-out;

    visibility: hidden;
    // z-index: -10;
    opacity: 0;
  }

  &:not(.soon):hover .overlay {
    visibility: visible;
    z-index: 1;
    opacity: 1;
  }

  &.soon {
    .template-body {
      cursor: default;
    }
  }
}

.skeleton {
  &:not(.thumbnail) {
    width: 80%;
  }

  &.thumbnail {
    height: 270px;
  }

  &.template-name {
    height: 14px;
    max-width: 120px;
  }

  &.views-count {
    height: 12px;
    max-width: 39px;
  }

  &.tags-name {
    height: 12px;
    width: 40px;
    max-width: 66px;
  }
}

.template-type {
  bottom: 8px;
  left: 16px;
  align-items: center;
  padding: 2px 6px;
  position: absolute;
  width: 48px;
  height: 22px;
  background: map-get($dark-blue, "200");
  box-sizing: border-box;
  border-radius: 3px;
  color: map-get($light-text, "low-contrast");
  text-transform: uppercase;

  svg {
    margin-right: 3px;
  }

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
  }
}

.ml-12px {
  margin-left: 12px;
}

.bottom-17px {
  bottom: 17px;
}
</style>
